import {useHarmonicIntervalFn} from 'react-use'

import style from './Phone.module.scss'

const Timer = memo(function Timer() {
  const [seconds, setSeconds] = useState(0)

  useHarmonicIntervalFn(() => {
    setSeconds(seconds => seconds + 1)
  }, 1000)

  const formatTime = (time: number) => {
    const mins = Math.floor(time / 60)
    const secs = time % 60
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }

  return (
    <div className={style.Timer} aria-hidden='true'>
      {formatTime(seconds)}
    </div>
  )
})

export default Timer
